import React from "react";
import { Dynamic } from "../../../../../controllers/conductor";
import SamedayDashboardController from "../../../../../controllers/dashboard/SamedayDashboard";
import { PieChart } from "../../../../../services/charts";
import { BarGraph } from "../../../../../services/charts/lib/bar";
import { Button } from "../../../../widgets/buttons";
import { MonthYearSelector } from "../../../../widgets/date_selector";
import { LoadingAnimation } from "../../../../widgets/loading";

/**
 * @param {{ controller: SamedayDashboardController }} param0 
 */
export function BarSection({ controller }) {
    const { data, notifiers, reference: { bar: { month, year } } } = controller;


    const sublabels = [ "DOMESTIC", "FOREIGN" ];
    const subcolors = [ "#EB695C", "#5484E1" ];



    return <section className="bar-section">
        <header>
            <div className="left">
                <span className="title">Sameday Tourist Arrivals Breakdown</span>
            </div>
            <div className="right">
                <MonthYearSelector month={month} year={year} onChange={date => controller.changeBarDate(date)} />
                <Button onClick={() => controller.downloadBar()} icon="save">Download</Button>
            </div>
        </header>
        <main>
            <Dynamic conductor={[ notifiers.barLoading, notifiers.barError ]} child={() => {        
                const dataset = [];
                for(const province of data.bar.children) {
                    const { id, name, total } = province;

                    const values = [ total?.domestic || 0, total?.foreign || 0 ];
                    dataset.push({ label: name, values });
                }

                return controller.status.barLoading ? 
                    <div className="loading"><center><LoadingAnimation /> Loading data...</center></div> :
                    <div className="bar-wrapper">
                        <BarGraph data={dataset} subcolors={subcolors} sublabels={sublabels} />
                    </div>;
            }} />
        </main>
        
    </section>;
}